import logo_footer from '../../../assets/images/logo_footer.png';
import logo_footer_sns01 from '../../../assets/images/ico_footer-sns01.png';
import logo_footer_sns02 from '../../../assets/images/ico_footer-sns02.png';
import logo_footer_sns03 from '../../../assets/images/ico_footer-sns03.png';
import logo_footer_sns04 from '../../../assets/images/ico_footer-sns04.png';
import logo_footer_sns05 from '../../../assets/images/ico_footer-sns05.png';
import logo_footer_sns06 from '../../../assets/images/ico_footer-sns06.png';

import React from 'react';

const HomeFooter = () => {
  return (
    <>
      <footer>
        <div className="inner-box">
          <a href="#" className="logo">
            <img src={logo_footer} alt="" />
          </a>
          <ul className="footer-sns">
            <li>
              <a href="https://www.therecharge.io/" target="_blank">
                <img src={logo_footer_sns05} alt="" />
              </a>
            </li>
            <li>
              <a href="https://discord.gg/pPvDW6jCr5" target="_blank">
                <img src={logo_footer_sns06} alt="" />
              </a>
            </li>
            <li>
              <a href="https://twitter.com/TheRecharge_AD" target="_blank">
                <img src={logo_footer_sns04} alt="" />
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </>
  );
};

export default HomeFooter;
